// Generated by CoffeeScript 2.7.0
// TODO: auto position when overflowed
var Popover;

export default Popover = Vue.extend({
  props: {
    customClass: {
      type: [String, Object, Array],
      default: ''
    },
    dynamicId: {
      type: String
    },
    turbolinksPermanent: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      // 'vertical-position horizontal-position'
      // vertical-position: ['top', 'bottom', 'center']
      // horizontal-position: ['left', 'right', 'center']
      default: 'top center'
    },
    caret: {
      type: Boolean,
      default: true
    },
    loadContent: {
      type: Boolean,
      default: false
    },
    manualToggle: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    },
    size: {
      type: String
    },
    blockContent: {
      type: Boolean,
      default: false
    },
    stopPropagation: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      opened: false,
      contentLoaded: this.loadContent,
      calculatedPosition: ''
    };
  },
  template: `<div class="popover" :id='dynamicId' :class='[{ open: opened, "without-caret": !caret, "block-content": blockContent }, parsedPosition, customClass, type, popoverSize]' :data-turbolinks-permanent='turbolinksPermanent'>
  <div class="trigger" ref='trigger' @click='togglePopover'>
    <slot name='trigger'></slot>
  </div>
  <div v-if='contentLoaded' class="content" ref='popoverContent'>
    <div class="caret" ref='caret' v-if='caret'></div>
    <slot name='content'></slot>
  </div>
</div>`,
  computed: {
    parsedPosition: function() {
      return (this.calculatedPosition || this.position).replace(/^center/, 'v-center').replace(/center$/, 'h-center');
    },
    popoverSize: function() {
      if (this.size) {
        return `popover-${this.size}`;
      }
    }
  },
  watch: {
    opened: function(new_value) {
      if (new_value) {
        return this.$emit('beforeOpen', this);
      } else {
        return this.$emit('beforeClose', this);
      }
    }
  },
  methods: {
    close: function() {
      this.opened = false;
      Skylark.Helpers.App.removeCapturedBackdropByID(this._backdropId);
      return this._backdropId = null;
    },
    open: function() {
      if (this.opened) {
        return;
      }
      this.contentLoaded = true;
      this.opened = true;
      this.$nextTick(function() {
        return this.calculatePosition();
      });
      return this._enableBackdrop();
    },
    togglePopover: function(event) {
      if (this.disabled) {
        if (this.opened) {
          this.close();
        }
        return;
      }
      if (this.manualToggle) {
        return this.$emit('triggerClicked', event);
      } else {
        if (this.opened) {
          return this.close();
        } else {
          return this.open();
        }
      }
    },
    calculatePosition: function() {
      var bottom_enough, buffer_width, content_client_rect, content_left, height, offsetX, popover, ref, scrollable_container, scrollable_container_client_rect, top_enough, trigger_client_rect;
      this._resetPosition();
      if (!this.$refs.popoverContent) {
        return;
      }
      scrollable_container = DomMaster.getScrollableContainer(this.$refs.trigger);
      scrollable_container_client_rect = scrollable_container.getBoundingClientRect();
      trigger_client_rect = this.$refs.trigger.getBoundingClientRect();
      content_client_rect = (ref = this.$refs.popoverContent) != null ? ref.getBoundingClientRect() : void 0;
      popover = DomMaster.wrap(this.$el);
      if (!this.calculatedPosition) {
        this.calculatedPosition = this.position;
      }
      buffer_width = 10;
      top_enough = trigger_client_rect.top - scrollable_container_client_rect.top > content_client_rect.height + buffer_width;
      bottom_enough = scrollable_container_client_rect.bottom - trigger_client_rect.bottom > content_client_rect.height + buffer_width;
      if (popover.containsClass('top')) {
        // 上面空间不够，下面空间足够时才自动调整，否则遵循设置，下同
        // 上下空间都不够，遵循设置，调整高度
        if (!top_enough && bottom_enough) {
          this.calculatedPosition = this.calculatedPosition.replace(/top/, 'bottom');
        } else if (!top_enough && !bottom_enough) {
          height = trigger_client_rect.top - scrollable_container_client_rect.top - buffer_width;
          this.$refs.popoverContent.style.height = height + 'px';
        }
      } else {
        if (!bottom_enough && top_enough) {
          this.calculatedPosition = this.calculatedPosition.replace(/bottom/, 'top');
        } else if (!top_enough && !bottom_enough) {
          height = scrollable_container_client_rect.bottom - trigger_client_rect.bottom - buffer_width;
          this.$refs.popoverContent.style.height = height + 'px';
        }
      }
      if (!(scrollable_container_client_rect.right > content_client_rect.right + buffer_width)) {
        this.calculatedPosition = this.calculatedPosition.replace(/left|right|center$/, '');
        offsetX = trigger_client_rect.left - (scrollable_container_client_rect.right - buffer_width - content_client_rect.width);
        this.$refs.popoverContent.style.left = -offsetX + 'px';
        if (this.caret) {
          this.$refs.caret.style.left = (offsetX + trigger_client_rect.width / 2 - 6) + 'px';
        }
      }
      if (!(scrollable_container_client_rect.left < content_client_rect.left - buffer_width)) {
        this.calculatedPosition = this.calculatedPosition.replace(/left|right|center$/, '');
        content_left = trigger_client_rect.left - scrollable_container_client_rect.left;
        offsetX = content_left - buffer_width;
        this.$refs.popoverContent.style.left = -offsetX + 'px';
        if (this.caret) {
          return this.$refs.caret.style.left = (offsetX + trigger_client_rect.width / 2 - 6) + 'px';
        }
      }
    },
    _resetPosition: function() {
      var ref, ref1;
      if ((ref = this.$refs.popoverContent) != null) {
        ref.setAttribute('style', null);
      }
      return (ref1 = this.$refs.caret) != null ? ref1.setAttribute('style', null) : void 0;
    },
    _enableBackdrop: function() {
      return this._backdropId = Skylark.Helpers.App.capturedBackdrop((event) => {
        if (this.$el.contains(event.target)) {
          return {
            force_clean: false
          };
        } else {
          this.opened = false;
          this.$emit('afterBackdropClose', event);
          if (this.stopPropagation) {
            return event.stopPropagation();
          }
        }
      }, this.$refs.popoverContent);
    }
  }
});
